__turbopack_context__.v({
  "alignItemsCenter": "_7FOJWW_alignItemsCenter",
  "authorName": "_7FOJWW_authorName",
  "bookBoxBody": "_7FOJWW_bookBoxBody",
  "bookCardBox": "_7FOJWW_bookCardBox",
  "bookImage": "_7FOJWW_bookImage",
  "category": "_7FOJWW_category",
  "container": "_7FOJWW_container",
  "dFlex": "_7FOJWW_dFlex",
  "dealspage__loader": "_7FOJWW_dealspage__loader",
  "descriptionText": "_7FOJWW_descriptionText",
  "desktopDescription": "_7FOJWW_desktopDescription",
  "imageContainer": "_7FOJWW_imageContainer",
  "imgBox": "_7FOJWW_imgBox",
  "justifyContentSpaceBetween": "_7FOJWW_justifyContentSpaceBetween",
  "loadMoreText": "_7FOJWW_loadMoreText",
  "loadingText": "_7FOJWW_loadingText",
  "mobielDescription": "_7FOJWW_mobielDescription",
  "mobileDescription": "_7FOJWW_mobileDescription",
  "mobileReviewSec": "_7FOJWW_mobileReviewSec",
  "moreLessButton": "_7FOJWW_moreLessButton",
  "moreText": "_7FOJWW_moreText",
  "oldPrice": "_7FOJWW_oldPrice",
  "previewLink": "_7FOJWW_previewLink",
  "pricingBox": "_7FOJWW_pricingBox",
  "pricingDetail": "_7FOJWW_pricingDetail",
  "promoBanner": "_7FOJWW_promoBanner",
  "promoPriceText": "_7FOJWW_promoPriceText",
  "readPreview": "_7FOJWW_readPreview",
  "reviewCount": "_7FOJWW_reviewCount",
  "reviewSec": "_7FOJWW_reviewSec",
  "siteBox": "_7FOJWW_siteBox",
  "siteListing": "_7FOJWW_siteListing",
  "star": "_7FOJWW_star",
  "titleText": "_7FOJWW_titleText",
});
